import React from 'react';
import { MinimizeScreen } from '../icons/FullScreenIcons';
import { Icon } from '@material-ui/core';

type Props = {
  isFullscreen: boolean;
  onClick: React.MouseEventHandler<HTMLElement>;
  type: 'main' | 'fullscreen';
};

export const FullscreenButton = React.memo(({ onClick }: Props) => {
  return (
    <button
      type="button"
      className="image-gallery-icon image-gallery-fullscreen-button"
      onClick={onClick}
      aria-label="Open Fullscreen"
    >
      <Icon style={{ fontSize: '48px', color: 'rgba(102, 102, 102, 0.6)' }}>close</Icon>
    </button>
  );
});
